module.exports = __webpack_public_path__ + "static/media/building_red_simple.010c7459.svg";